import moment from 'moment';

import { formatDateTime } from '../constants/app-constants';
import NumberUtils from './number-utils';

export default class DateTimeUtils {
	static parseDateToMoment(date) {
		if (!date) {
			return null;
		}
		return moment(date);
	}

	static parseDateToFullDate(date, format = formatDateTime.DDMMMYYYY_SPACE) {
		if (!date) {
			return null;
		}
		return moment(date).format(format);
	}

	static parseDateToString(date, format = formatDateTime.DDMMYYYY_SLASH) {
		if (!date) {
			return null;
		}
		return moment(date).format(format);
	}

	static parseStringToDate(dateString, format = formatDateTime.DDMMYYYY_SLASH) {
		if (!dateString) {
			return null;
		}
		return moment(dateString, format).toDate();
	}

	static parseNumberToDate(dateNumber) {
		if (!dateNumber) {
			return null;
		}
		return moment(dateNumber).toDate();
	}

	static clearTime(date) {
		const d = new Date(date);
		d.setHours(0, 0, 0, 0);
		return d;
	}

	static parseString(dateString, parseFormat, expectFormat) {
		if (!dateString || !parseFormat || !expectFormat) {
			return null;
		}
		return moment(dateString, parseFormat).format(expectFormat);
	}

	static getCurrentMomentDateTime() {
		return moment();
	}

	static getCurrentDateTime() {
		return moment().toDate();
	}

	static getCurrentDate() {
		return moment()
			.startOf('day')
			.toDate();
	}

	static getGapDaysBetweenDate(date1, date2, options = { abs: false }) {
		var time = NumberUtils.subtract(
			this.parseNumberToDate(date2).getTime(),
			this.parseNumberToDate(date1).getTime()
		);
		// var days = time / (1000 * 3600 * 24);
		const days = NumberUtils.divide(time, NumberUtils.multiply(NumberUtils.multiply(1000, 3600), 24));

		if (options && options.abs) {
			return Math.abs(days);
		}
		return days;
	}

	static getCurrentDateTimeString(format = formatDateTime.DDMMYYYY_SLASH) {
		return moment().format(format);
	}

	/**
	 *
	 * @param {* if pass null or undefined date will current date} date
	 * @param {* years|y, quarters|q, months|M, weeks|w, days|d, hours|h, minutes|m, seconds|s, milliseconds|ms } Key
	 * @param {* number for add}
	 */
	static addDate(date = this.getCurrentDateTime(), key, nums) {
		return moment(date)
			.add(nums, key)
			.toDate();
	}

	static checkCurrentDateBetween(startDate, endDate) {
		return moment().isBetween(startDate, endDate);
	}

	static checkCurrentDate(date) {
		return moment(this.getCurrentDate()).isSame(this.parseNumberToDate(date),'day');
	}
}
